export const SCREEN_NAME = {
  HOME_PAGE: "HomePage",
  PROFILE: "MesCoord"
};

export const ACTION_KEY = {
  CLICK_SEPA_BUTTON_GENERATE: "SepaButtonGenerateMandate",
  SUBSCRIBE_SEPA_DIRECT_DEBIT: "SepaBannerToSubscribe",
  SEPA_BANNER_END_SUBSCRIPTIONS: "SepaBannerEndSubcsription",
  SEPA_LINK_END_SUBSCRIPTIONS: "SepaLinkEndSubcsription"
};
